import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { commonApiPostWithoutBodyAndResponse } from "@/services/api/common-api";
interface UseWaveDropsNotificationReadParams {
  readonly waveId: string;
  readonly removeWaveDeliveredNotifications: (waveId: string) => Promise<unknown> | void;
}
export const useWaveDropsNotificationRead = t0 => {
  const $ = _c(4);
  const {
    waveId,
    removeWaveDeliveredNotifications
  } = t0;
  let t1;
  let t2;
  if ($[0] !== removeWaveDeliveredNotifications || $[1] !== waveId) {
    t1 = () => {
      removeWaveDeliveredNotifications(waveId);
      commonApiPostWithoutBodyAndResponse({
        endpoint: `notifications/wave/${waveId}/read`
      }).catch(_temp);
    };
    t2 = [waveId, removeWaveDeliveredNotifications];
    $[0] = removeWaveDeliveredNotifications;
    $[1] = waveId;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
};
function _temp(error) {
  return console.error("Failed to mark feed as read:", error);
}